import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../Brand/Logo.js';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle: string;
  backTo?: string;
}

export function AuthLayout({ children, title, subtitle, backTo = '/' }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-background px-4 py-6 md:grid md:grid-cols-[1.1fr_0.9fr] md:gap-0 md:px-0 md:py-0">
      <aside className="relative hidden overflow-hidden border-r border-border/60 bg-surface-elevated md:flex md:min-h-screen md:flex-col md:justify-between md:px-14 md:py-12">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,hsl(var(--color-success)/0.16),transparent_34%),radial-gradient(circle_at_bottom_right,hsl(var(--color-warning)/0.14),transparent_26%)]" />
        <div className="relative z-10">
          <Logo />
        </div>
        <div className="relative z-10 mx-auto flex max-w-xl flex-1 flex-col items-center justify-center text-center">

          <h1 className="max-w-md text-5xl font-display font-extrabold leading-[1.05] text-text">
            {title}
          </h1>
          <p className="mt-5 max-w-lg text-lg leading-8 text-text-muted">{subtitle}</p>
          <div className="mt-10 flex gap-3 text-sm font-semibold text-text-muted">
            <span className="rounded-pill bg-surface px-4 py-2 shadow-sm">Bank-level security</span>
            <span className="rounded-pill bg-surface px-4 py-2 shadow-sm">Instant transfers</span>
          </div>
        </div>
      </aside>

      <main className="mx-auto flex w-full max-w-md items-center justify-center md:max-w-none md:px-12">
        <div className="w-full rounded-[2rem] border border-border/80 bg-surface px-6 py-7 shadow-[0_22px_65px_hsl(var(--color-text)/0.08)] md:max-w-md md:border-0 md:bg-transparent md:px-0 md:py-0 md:shadow-none">
          <div className="mb-8 flex items-center justify-between md:hidden">
            <Link
              to={backTo}
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-border bg-surface-elevated text-text"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5" />
                <path d="M12 19l-7-7 7-7" />
              </svg>
            </Link>
            <Logo className="text-xl" />
            <span className="w-11" aria-hidden="true" />
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
